// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"InvoiceModal_modalBody__3fQFP","modalFooter":"InvoiceModal_modalFooter__1TQtx"};